import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Dashboard = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 20">
      <path d="M4.5,20c-0.414,0 -0.75,-0.336 -0.75,-0.75c0,-0.414 0.336,-0.75 0.75,-0.75l4.75,0l0,-0.5l-6.25,0c-1.64,0 -2.973,-1.31 -3,-2.935l0,-12.08c0,-1.633 1.316,-2.959 2.95,-2.985l18.05,0c1.64,0 2.973,1.31 3,2.935l0,12.08c0,1.632 -1.316,2.958 -2.95,2.985l-6.238,0l0,0.5l4.688,0c0.414,0 0.75,0.336 0.75,0.75c0,0.414 -0.336,0.75 -0.75,0.75l-15,0Zm8.812,-1.5l0,-0.5l-2.562,0l0,0.5l2.562,0Zm-10.319,-17c-0.816,0 -1.48,0.647 -1.5,1.453l0,12.056c0,0.81 0.65,1.47 1.462,1.49l0.038,0.001l18.014,0c0.816,0 1.48,-0.647 1.5,-1.453l0,-12.056c0,-0.81 -0.65,-1.47 -1.462,-1.49l-0.038,-0.001l-18.014,0Zm17.257,12c0.414,0 0.75,0.336 0.75,0.75c0,0.414 -0.336,0.75 -0.75,0.75l-8,0c-0.414,0 -0.75,-0.336 -0.75,-0.75c0,-0.414 0.336,-0.75 0.75,-0.75l8,0Zm-10.5,-10.5c0.414,0 0.75,0.336 0.75,0.75l0,10.5c0,0.414 -0.336,0.75 -0.75,0.75c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-10.5c0,-0.414 0.336,-0.75 0.75,-0.75Zm-3,3.625c0.414,0 0.75,0.336 0.75,0.75l0,6.875c0,0.414 -0.336,0.75 -0.75,0.75c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-6.875c0,-0.414 0.336,-0.75 0.75,-0.75Zm-3,2c0.414,0 0.75,0.336 0.75,0.75l0,4.875c0,0.414 -0.336,0.75 -0.75,0.75c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-4.875c0,-0.414 0.336,-0.75 0.75,-0.75Zm12.5,-5.625c2.623,0 4.75,2.127 4.75,4.75c0,2.623 -2.127,4.75 -4.75,4.75c-2.623,0 -4.75,-2.127 -4.75,-4.75c0,-2.623 2.127,-4.75 4.75,-4.75Zm0,1.5c-1.795,0 -3.25,1.455 -3.25,3.25c0,1.795 1.455,3.25 3.25,3.25c1.795,0 3.25,-1.455 3.25,-3.25c0,-1.795 -1.455,-3.25 -3.25,-3.25Z" />
    </svg>
  );
};

Dashboard.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Dashboard;
